export const HMapConstants = {
    GET_HMAP: 'GET_HMAP',
    SET_HMAP: 'SET_HMAP'
};